import { render, staticRenderFns } from "./EventSummaries.vue?vue&type=template&id=2aaa4d15&"
import script from "./EventSummaries.vue?vue&type=script&lang=js&"
export * from "./EventSummaries.vue?vue&type=script&lang=js&"
import style0 from "./EventSummaries.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports